import { createContext, useContext } from "react"

/** Who is signed in, for the parts of the page that show it. */
export interface SignedIn {
  email: string | null
  signOut: () => Promise<void>
}

export const SignedInContext = createContext<SignedIn | null>(null)

/** The signed-in user, or null when sign-in is switched off on this server. */
export function useSignedIn(): SignedIn | null {
  return useContext(SignedInContext)
}
